<div class="simple-pagnator">
    <button mat-raised-button class="nav-button" (click)="onPreviousPage()"
        [disabled]="istFirstPage()">Previous</button>
    <span class="page-info">{{getPageInfo()}}</span>
    <button mat-raised-button class="nav-button" (click)="onNextPage()" [disabled]="isLastPage()">Next</button>
</div>